// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlaySquareTwoToneSvg from "@fishx/icons-svg/es/asn/PlaySquareTwoTone";
import FishxIcon from '../components/FishxIcon';

var PlaySquareTwoTone = function PlaySquareTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlaySquareTwoToneSvg
  }));
};

PlaySquareTwoTone.displayName = 'PlaySquareTwoTone';
export default React.forwardRef(PlaySquareTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PlaySquareTwoTone.js
// module id = 3814
// module chunks = 0